import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.to-string.js";
import router from '@/router';
axios.interceptors.response.use(function (config) {
  return config;
}, function (error) {
  var _error$response, _error$message;
  // console.log('error obj in axios interceptor response', error)

  // timeout、斷線、server 沒回時沒有 error.response —— 不能直接點進去，
  // 否則這裡拋 TypeError，呼叫端看到的是 undefined 而不是「逾時」
  if (((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 401) {
    localStorage.removeItem('userDetail');
    router.push({
      path: 'login'
    }).catch(function (err) {
      return console.log('router push has error', err);
    });
  } else if (error !== null && error !== void 0 && (_error$message = error.message) !== null && _error$message !== void 0 && _error$message.includes('status code 500')) {
    return Promise.reject(error);
  } else {
    var _error$response$data, _error$response2;
    return Promise.reject((_error$response$data = (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.data) !== null && _error$response$data !== void 0 ? _error$response$data : error);
  }
});
export default axios;